import { useDescope } from '@descope/react-sdk';

export function useDescopeSdk(): ReturnType<typeof useDescope> | null {
  try {
    return useDescope();
  } catch {
    return null;
  }
}
